export const webSafeFonts = [
    "Arial, sans-serif",
    "Verdana, sans-serif",
    "Tahoma, sans-serif",
    "'Times New Roman', serif",
    "Georgia, serif",
    "Garamond, serif",
    "'Courier New', monospace",
    "'Brush Script MT', cursive"
];